export default __webpack_public_path__ + "static/media/u1.a0bbdd9f.svg";